$.fn.filterDocuments = function(result_container_selector, filter_buttons_selector) {
  let self = this

  function toggle_menu() {
    var height = self.find('.js-accordion').outerHeight();
    self.find('.js-filter-toggle-content').css('--max-height', height+'px');
    self.toggleClass('--open');
  }

  self.find('.js-filter-toggle').click(function() {
    toggle_menu();
  });

  $(filter_buttons_selector).click(function() {
    event.preventDefault();
    toggle_menu();
    var slug = $(this).attr('href').replace('#','');
    $(result_container_selector).addClass('loading');
    $.ajax({
      url:'/wp/wp-admin/admin-ajax.php',
      data:'term_slug='+slug+'&action=myfilter',
      type:'POST',
      success:function(data){
        $(result_container_selector).html(data);
        $(result_container_selector).removeClass('loading');
        $('.documentation__breadcrumbs').each(function() {
          $(this).filterDocuments('.js-filter-documents-results', '.documentation__breadcrumbs a')
        })
      }
    });
  });

  return function() {
    return self
  }()
};
